import Component from './Alert.vue';

export default Component;
